import { render, staticRenderFns } from "./VaTopbar.vue?vue&type=template&id=7271ac1b&"
import script from "./VaTopbar.vue?vue&type=script&lang=js&"
export * from "./VaTopbar.vue?vue&type=script&lang=js&"
import style0 from "./VaTopbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports